import { render, staticRenderFns } from "./dialog-form-wrapper.vue?vue&type=template&id=29b588cc"
import script from "./dialog-form-wrapper.vue?vue&type=script&lang=js"
export * from "./dialog-form-wrapper.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/mse/texting-service/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('29b588cc')) {
      api.createRecord('29b588cc', component.options)
    } else {
      api.reload('29b588cc', component.options)
    }
    module.hot.accept("./dialog-form-wrapper.vue?vue&type=template&id=29b588cc", function () {
      api.rerender('29b588cc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/pages/brand/dialog-form-wrapper.vue"
export default component.exports